import React from "react";
import ResumeMiningDetails from "./AutomationConfigurationTabs/ResumeMiningDetails";
import { VerticalTabs } from "../../../../../components";

const Automation = () => {
  const tabList = [
    {
      title: "Resume Mining Settings",
      id: "settings_configurations_automation",
      page: (
        <div className="flex-1 p-2 flex flex-col">
          <ResumeMiningDetails />
        </div>
      ),
    },
  ];

  return (
    <div className="my-2">
      <VerticalTabs
        tabs={tabList}
        activeColor="primary"
        activeVariant="contained"
      />
    </div>
  );
};

export default Automation;
